import React, { useEffect, useRef } from 'react'
import './index.css'
import { useNavigate } from 'react-router-dom'

export default function CustomerDemands(props) {
    const { bid, cid, pdid, pdq, pdn, dd, selectedBlock, setHeight } = props;
    // const {  setSelectedBlock } = props;

    const navigate = useNavigate();

    // let monthNames = ["Jan", "Feb", "Mar", "Apr",
    //     "May", "Jun", "Jul", "Aug",
    //     "Sep", "Oct", "Nov", "Dec"];

    return (
        <main className='CustomerDemands_boxPadding'>
            <div className='CustomerDemands_box'
                style={selectedBlock === bid ?
                    { backgroundColor: "rgba(235,245,179,255)" } : null} onClick={() => { /*setSelectedBlock(bid)*/ }}>
                <br /><br />
                <div style={{ "text-align": "center" }}>Block {bid}</div>
                <br />
                <input style={{ width: "100%" }} type="button" value="Detail" onClick={() => { navigate(`/game2blockdetail/${bid}`) }} />
            </div>
        </main>
    )

}
